import React from 'react';
import { Badge, Dropdown } from 'react-bootstrap';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import RequireAuth from '../../../auth/middleware/RequireAuth';
import ReadOnlyGuard from '../../../shared/components/ReadOnlyGuard';
import { Category } from '../types';

interface StockCategoriesTableProps {
    categories: Category[];
    onEdit: (id: string) => void;
    onDelete: (id: string) => void;
}

const StockCategoriesTable: React.FC<StockCategoriesTableProps> = ({
    categories,
    onEdit,
    onDelete
}) => {
    return (
        <>
            {/* Desktop Table */}
            <table className="table table-striped d-none d-md-table">
                <thead>
                    <tr>
                        <th>Category Name</th>
                        <th className='text-end'>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.length > 0 ? categories.map((category) => (
                        <tr key={category.id}>
                            <td>
                                <Badge bg="secondary" className="fs-6 text-white">
                                    {category.name}
                                </Badge>
                            </td>
                            <td className="text-end">
                                <Dropdown>
                                    <Dropdown.Toggle variant="default" id={`dropdownCategory-${category.id}`}>
                                        Actions
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_update']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onEdit(category.id.toString())}>
                                                    <IconEdit size={14} className="me-2" />
                                                    Edit
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_delete']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onDelete(category.id.toString())} className='text-danger'>
                                                    <IconTrash size={14} className="me-2" />
                                                    Remove
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={2} className="text-center">No categories found.</td>
                        </tr>
                    )}
                </tbody>
            </table>

            {/* Mobile Cards */}
            <div className="d-md-none">
                {categories.length > 0 ? categories.map((category) => (
                    <div key={category.id} className="card mb-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 className="card-title mb-1">
                                        <Badge bg="secondary" className="fs-6 text-white">
                                            {category.name}
                                        </Badge>
                                    </h6>
                                </div>
                                <Dropdown>
                                    <Dropdown.Toggle variant="default" id={`dropdownMobileCategory-${category.id}`}>
                                        Actions
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_update']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onEdit(category.id.toString())}>
                                                    <IconEdit size={14} className="me-2" />
                                                    Edit
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                        <RequireAuth requiredRoles={['dev']} requiredPermissions={['stock_inventory_delete']} asComponent>
                                            <ReadOnlyGuard mode="hide">
                                                <Dropdown.Item href="#" onClick={() => onDelete(category.id.toString())} className='text-danger'>
                                                    <IconTrash size={14} className="me-2" />
                                                    Remove
                                                </Dropdown.Item>
                                            </ReadOnlyGuard>
                                        </RequireAuth>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                )) : (
                    <div className="text-center my-4">No categories found.</div>
                )}
            </div>
        </>
    );
};

export default StockCategoriesTable;
